/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Tool choice mode: Selects how the model decides tool usage. Use none, auto, or required.
 */
export const ToolChoiceMode = {
  None: "none",
  Auto: "auto",
  Required: "required",
} as const;
/**
 * Tool choice mode: Selects how the model decides tool usage. Use none, auto, or required.
 */
export type ToolChoiceMode = ClosedEnum<typeof ToolChoiceMode>;

/** @internal */
export const ToolChoiceMode$inboundSchema: z.ZodNativeEnum<
  typeof ToolChoiceMode
> = z.nativeEnum(ToolChoiceMode);
/** @internal */
export const ToolChoiceMode$outboundSchema: z.ZodNativeEnum<
  typeof ToolChoiceMode
> = ToolChoiceMode$inboundSchema;
